import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/sk-aqua/sk-aqua/node_modules/next/dist/client/app-dir/link.js");
